import React from 'react';
import {Button, DatePicker, Form, Icon, Input, message, Modal, Tag, Upload} from 'antd';
import moment from "moment";

const {TextArea} = Input;

class Suspend extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      asset: '',
      from: '',
      to: '',
      docs: [],
      docIds: [],
      description: '',
      susRecId: null,
    };
  }

  onCancel = () => {
    this.props.showToggle(this.props.contract, this.props.assetRecord);
  }

  componentDidMount() {
    // console.log(this.props.suspenseRecord)
    if(this.props.suspenseRecord) {
      const {data: currentData} = this.props;
      const asset = currentData.assets.filter(item => item.id === this.props.assetRecord)
      if(asset && asset[0]) {
        const susRecord = asset[0].suspensionInfo.filter(item => item.id === this.props.suspenseRecord)
        if(susRecord && susRecord[0]) {
          // console.log(susRecord[0]);
          this.setState({
            from: moment(susRecord[0].suspensionFrom),
            to: moment(susRecord[0].suspensionTo),
            description: susRecord[0].suspensionDescription,
            susRecId: susRecord[0].id,
          });

        }
      }
    } else {
      this.setState({
        from: null,
        to: null,
        description: '',
        susRecId: null,
      });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.uploadedDocument && nextProps.uploadedDocument.file && nextProps.uploadedDocument._id !== this.props.uploadedDocument._id) {
      const doc = this.state.docs;
      const docIds = this.state.docIds;
      doc.push({
        uid: nextProps.uploadedDocument._id,
        name: nextProps.uploadedDocument.file.name,
        status: 'done',
        url: nextProps.uploadedDocument.file.path,
      });
      docIds.push(nextProps.uploadedDocument._id)
      this.setState({
        docs: doc,
        docIds
      });
    }
  }

  onChange = (value, name) => {
    // console.log(value)
    if(name === 'asset')
      this.setState({
        asset: value
      });
    if(name === 'from')
      this.setState({
        from: value
      });
    if(name === 'to')
      this.setState({
        to: value
      });
    if(name === 'description')
      this.setState({
        description: value.target.value
      });
  };

  validate = () => {
    const {data: currentData} = this.props;
    const {from, to} = this.state;
    const {assetLeasePeriod, suspensionInfo} = currentData;
    // todo compare period too also have to validate with the assets records
    const checkedAssets = [];//assetLeasePeriod.map(item => item.leasingAsset._id === asset);
    if(checkedAssets && checkedAssets.length > 0 && checkedAssets.includes(true)) {
      return true;
    } else {
      message.error('Asset record not exist');
      return false;
    }
  }

  ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

  onCreate = () => {
    const {from, to} = this.state;
    if(from && to) {

      this.props.suspendRecord(this.props.contract, this.props.assetRecord, this.state.susRecId ? 'update' : 'new',
        {
          id: this.state.susRecId ? this.state.susRecId : this.ObjectId(),
          suspensionFrom: from,
          suspensionTo: to,
          suspensionDocuments: this.state.docIds,
          suspensionDescription: this.state.description,
        }
      );
      this.onCancel();
    }
  }

  disabledDate = (current) => {
    const {data} = this.props;
    const assetData = data.assets.filter(doc => doc._id === this.props.assetRecord);
    if(assetData && assetData[0]) {
      const fromDate = assetData[0].periodFrom;
      const toDate = assetData[0].periodTo;
      return current && !moment(current).isBetween(moment(fromDate).startOf('day'), moment(toDate).endOf('day'));
    }
  }

  getDocumentData = (data) => {
    this.setState({docs: data});
  };

  handleChange = ({file}) => {
    if(file && file.originFileObj)
      this.props.uploadDocuments({file: file.originFileObj});
  }

  render() {
    const {visible, onCreate, form} = this.props;
    // console.log(this.state)
    return (
      <div>
        <Modal
          visible={visible}
          title={this.state.susRecId ? "Update suspend record" : "Add suspend record"}
          okText=" Save"
          onCancel={this.onCancel}
          onOk={this.onCreate}
        >
          <Form layout="vertical">
            <Form.Item key={`from`} label={'Period From'} style={{width: '100%'}}>
              <DatePicker
                disabledDate={this.disabledDate}
                defaultValue={this.state.from}
                onChange={(e) => this.onChange(e, 'from')}/>
            </Form.Item>

            <Form.Item key={`to`} label={'Period To'} style={{width: '100%'}}>
              <DatePicker
                disabledDate={this.disabledDate}
                defaultValue={this.state.to}
                onChange={(e) => this.onChange(e, 'to')}/>
            </Form.Item>

            <Form.Item key={`desc`} label={'Description'} style={{width: '100%'}}>
              <TextArea
                rows={4}
                defaultValue={this.state.description}
                onChange={(e) => this.onChange(e, 'description')}/>
            </Form.Item>

            <Upload
              onChange={this.handleChange}
              multiple={true}
              fileList={this.state.docs}>
              <Button>
                <Icon type=" upload"/> Upload
              </Button>
            </Upload>
            {this.state.susRecId ? (
              <Tag color="orange">(Previously uploaded documents will be overwritten)</Tag>) : null}

          </Form>
        </Modal>
      </div>
    );
  }
}

export default Suspend;
